import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { L, List, Flag } from 'nallian-shared-ui/lib/components';
import { formatDateTime, formatRelativeTime } from 'nallian-shared-ui/lib/lib/dateTime';
import { withTranslation } from 'react-i18next';
import CountryName from '../../app/components/CountryName';

const VehicleDetailsList = ({ vehicle, t }) => (
  <List>
    <L.Item header={t('type')} content={get(vehicle, 'type', '...')} />
    <L.Item
      header={t('country')}
      content={
        vehicle && vehicle.countryCode ? (
          <Fragment>
            <Flag name={vehicle.countryCode.toLowerCase()} />{' '}
            <CountryName code={vehicle.countryCode} />
          </Fragment>
        ) : (
          '...'
        )
      }
    />
    <L.Item header={t('createdBy')} content={vehicle ? vehicle.createdBy : '...'} />
    <L.Item header={t('owner')} content={get(vehicle, 'owner', '...')} />
    <L.Item
      header={t('createdOn')}
      content={
        <Fragment>
          {vehicle ? formatDateTime(vehicle.createdOn) : '...'}
          <br /> {vehicle ? formatRelativeTime(vehicle.createdOn) : ''}
        </Fragment>
      }
    />
    <L.Item
      header={t('modifiedOn')}
      content={
        <Fragment>
          {vehicle ? formatDateTime(vehicle.modifiedOn) : '...'}
          <br /> {vehicle ? formatRelativeTime(vehicle.modifiedOn) : ''}
        </Fragment>
      }
    />
    {/* <L.Item
      header={t('lastSeenOn')}
      content={
        <Fragment>
          {vehicle ? formatDateTime(vehicle.lastSeenOn || vehicle.createdOn) : '...'}
          <br /> {vehicle ? formatRelativeTime(vehicle.lastSeenOn || vehicle.createdOn) : ''}
        </Fragment>
      }
    /> */}
  </List>
);

VehicleDetailsList.propTypes = { vehicle: PropTypes.object, t: PropTypes.func.isRequired };
VehicleDetailsList.defaultProps = { vehicle: undefined };

export default withTranslation()(VehicleDetailsList);
